import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';
import styled from '@material-ui/styles/styled';

import { useProductPhoto } from '../../store/scanSession/selectors';

const Image = styled('img')({
	maxHeight: '400px',
	width: '100%',
	objectFit: "contain"
});

const ProductPhoto = ({ src, ...props }) => {
	const imageSrc = useProductPhoto() || src;
	const theme = useTheme();
	return imageSrc ? (
		<Grid container justify="center" style={{ padding: theme.spacing(0.5, 1.5) }}> 
			<Image src={imageSrc} alt="Product" />
		</Grid>
	) : null;
};

ProductPhoto.propTypes = {
	src: PropTypes.string,
};

export default ProductPhoto;
